'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const initial = require('../_chunk/initial-y0QrPY.js');

function flattenDeep(arr) {
    return initial.flatten(arr, Infinity);
}

function orderBy(collection, keys, orders) {
    const effectiveOrders = keys.map((_, index) => orders[index] || orders[orders.length - 1]);
    return collection.slice().sort((a, b) => {
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const order = effectiveOrders[i];
            const result = initial.compareValues(a[key], b[key], order);
            if (result !== 0) {
                return result;
            }
        }
        return 0;
    });
}

exports.chunk = initial.chunk;
exports.compact = initial.compact;
exports.countBy = initial.countBy;
exports.difference = initial.difference;
exports.differenceBy = initial.differenceBy;
exports.differenceWith = initial.differenceWith;
exports.drop = initial.drop;
exports.dropRight = initial.dropRight;
exports.dropRightWhile = initial.dropRightWhile;
exports.dropWhile = initial.dropWhile;
exports.fill = initial.fill;
exports.flatMap = initial.flatMap;
exports.flatten = initial.flatten;
exports.forEachRight = initial.forEachRight;
exports.groupBy = initial.groupBy;
exports.head = initial.head;
exports.initial = initial.initial;
exports.intersection = initial.intersection;
exports.intersectionBy = initial.intersectionBy;
exports.intersectionWith = initial.intersectionWith;
exports.isSubset = initial.isSubset;
exports.keyBy = initial.keyBy;
exports.last = initial.last;
exports.maxBy = initial.maxBy;
exports.minBy = initial.minBy;
exports.partition = initial.partition;
exports.sample = initial.sample;
exports.sampleSize = initial.sampleSize;
exports.shuffle = initial.shuffle;
exports.sortBy = initial.sortBy;
exports.tail = initial.tail;
exports.take = initial.take;
exports.takeRight = initial.takeRight;
exports.takeRightWhile = initial.takeRightWhile;
exports.takeWhile = initial.takeWhile;
exports.toFilled = initial.toFilled;
exports.union = initial.union;
exports.unionBy = initial.unionBy;
exports.unionWith = initial.unionWith;
exports.uniq = initial.uniq;
exports.uniqBy = initial.uniqBy;
exports.uniqWith = initial.uniqWith;
exports.unzip = initial.unzip;
exports.unzipWith = initial.unzipWith;
exports.without = initial.without;
exports.xor = initial.xor;
exports.xorBy = initial.xorBy;
exports.xorWith = initial.xorWith;
exports.zip = initial.zip;
exports.zipObject = initial.zipObject;
exports.zipWith = initial.zipWith;
exports.flattenDeep = flattenDeep;
exports.orderBy = orderBy;
